export const PickerWorkerlistResource = {
  name: "Picker Worker List",
  path: "/pickpack/picker-workerlist",
  access: ["read-pickerworkerlists"],
};
